import { render, staticRenderFns } from "./UserManagement.vue?vue&type=template&id=f96673ac&scoped=true"
import script from "./UserManagement.vue?vue&type=script&lang=ts"
export * from "./UserManagement.vue?vue&type=script&lang=ts"
import style0 from "./UserManagement.vue?vue&type=style&index=0&id=f96673ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96673ac",
  null
  
)

export default component.exports